"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRefreshCtxTool = createRefreshCtxTool;
const path = __importStar(require("path"));
const fsExtra = __importStar(require("fs-extra"));
const getState_1 = require("../../../app/dist/getState");
const dist_1 = require("../../../fs/dist");
const dist_2 = require("../../../fs/dist");
const frontmatterUtils_1 = require("../../../core/dist/frontmatterUtils");
const dist_3 = require("../../../app/dist");
/**
 * loom_refresh_ctx — assemble, don't generate (design D1=b).
 *
 * No server-side inference. The tool: (1) assembles the scope's source, (2) ensures
 * the ctx doc exists at the canonical flat path with the current `source_hash` in its
 * frontmatter, and (3) returns the source for the agent to summarise (the agent then
 * calls loom_update_doc on the returned ctxId — which preserves frontmatter, so the
 * hash the tool wrote is what persists). Works identically in CLI and the extension.
 */
function createRefreshCtxTool() {
    return {
        toolDef: {
            name: 'loom_refresh_ctx',
            description: 'Prepare a ctx (re)generation. Assembles the scope source, ensures the ctx doc shell at the canonical flat path, and returns the source for the agent to summarise — then call loom_update_doc on the returned ctxId with the summary body. No server-side inference (works in any host). scope "global" -> loom/ctx.md (id loom-ctx); scope "weave" -> loom/{weave_slug}/ctx.md (id {weave_slug}-ctx). Returns stale=false when the source is unchanged since the last generation (source_hash).',
            inputSchema: {
                type: 'object',
                properties: {
                    scope: { type: 'string', enum: ['global', 'weave'], description: 'ctx scope (global or weave)' },
                    weave_slug: { type: 'string', description: 'Weave folder slug (required when scope = "weave")' },
                },
                required: ['scope'],
            },
        },
        handle: async (root, args) => {
            const scope = args['scope'];
            const weaveId = args['weave_slug'];
            if (scope !== 'global' && scope !== 'weave') {
                throw new Error(`Invalid scope "${scope}" — expected "global" or "weave"`);
            }
            if (scope === 'weave' && !weaveId) {
                throw new Error('weave_slug is required when scope = "weave"');
            }
            const registry = new dist_2.ConfigRegistry();
            const state = await (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs: fsExtra, workspaceRoot: root });
            const source = (0, dist_3.buildCtxSource)(scope, weaveId, state);
            const sourceHash = (0, dist_3.computeSourceHash)(source);
            const target = (0, dist_3.ctxTarget)(scope, weaveId);
            const loomRoot = (0, dist_1.getActiveLoomRoot)(root);
            const filePath = path.join(loomRoot, target.relPath);
            const exists = await fsExtra.pathExists(filePath);
            let version = 1;
            let stale = true;
            let body = `# ${target.title}\n`;
            if (exists) {
                const raw = await fsExtra.readFile(filePath, 'utf8');
                const hashMatch = raw.match(/^source_hash:\s*(\S+)/m);
                stale = !hashMatch || hashMatch[1] !== sourceHash;
                const verMatch = raw.match(/^version:\s*(\d+)/m);
                version = verMatch ? Number(verMatch[1]) : 1;
                const bodyMatch = raw.match(/^---[\s\S]*?\n---\n?([\s\S]*)$/);
                if (bodyMatch)
                    body = bodyMatch[1];
            }
            // (Re)write the doc only when missing or stale, so an up-to-date ctx is left
            // untouched. The frontmatter carries the new source_hash; the body is preserved
            // for the agent to overwrite via loom_update_doc.
            if (!exists || stale) {
                const fm = (0, dist_3.buildCtxFrontmatter)({ ctxId: target.ctxId, title: target.title, version, sourceHash });
                await fsExtra.ensureDir(path.dirname(filePath));
                await fsExtra.writeFile(filePath, `${(0, frontmatterUtils_1.serializeFrontmatter)(fm)}\n${body}`, 'utf8');
            }
            return {
                content: [{
                        type: 'text',
                        text: JSON.stringify({ ctxId: target.ctxId, scope, targetPath: filePath, stale, source }, null, 2),
                    }],
            };
        },
    };
}
